export const getStatusOptions = (t) => [
  { key: "Active",   label: t.statusActive },
  { key: "OnLeave",  label: t.statusOnLeave },
  { key: "Inactive", label: t.statusInactive },
];

export const getGenderOptions = (t) => [
  { key: "Male",   label: t.male },
  { key: "Female", label: t.female },
];

export const getMaritalOptions = (t) => [
  { key: "Single",   label: t.single },
  { key: "Married",  label: t.married },
  { key: "Divorced", label: t.divorced },
  { key: "Widowed",  label: t.widowed },
];

export const getLaborModeOptions = (t) => [
  { key: "Full-time",  label: t.fullTime },
  { key: "Part-time",  label: t.partTime },
  { key: "Contract",   label: t.contract },
  { key: "Temporary",  label: t.temporary },
  { key: "Freelance",  label: t.freelance },
];